import { createContext } from "react";

export interface ThemeContextType {
  themeStyle: "violet";
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);